// frontend/src/services/requestCache.js

// Кэш GET-запросов в памяти вкладки: TTL 3 минуты, дедупликация параллельных запросов.
const TTL = 3 * 60 * 1000;
const cache = new Map();
const pending = new Map();
function scope() {
  try {
    const token = localStorage.getItem('access_token');
    if (!token) return 'anonymous';
    const payload = token.split('.')[1];
    const claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return String(claims.user_id ?? claims.userId ?? claims.sub ?? 'authenticated');
  } catch (_) { return localStorage.getItem('access_token') ? 'authenticated' : 'anonymous'; }
}
function stable(v) {
  if (Array.isArray(v)) return `[${v.map(stable).join(',')}]`;
  if (v && typeof v === 'object') return `{${Object.keys(v).sort().map(k => `${JSON.stringify(k)}:${stable(v[k])}`).join(',')}}`;
  return JSON.stringify(v);
}
export function requestCacheKey(namespace, params = {}) { return `${scope()}::${namespace}::${stable(params)}`; }
export function getCached(key, ttl = TTL) {
  const item = cache.get(key);
  if (!item) return undefined;
  if (Date.now() - item.time >= ttl) { cache.delete(key); return undefined; }
  return item.value;
}
export async function cachedRequest(key, request, { force = false, ttl = TTL } = {}) {
  if (!force) {
    const value = getCached(key, ttl);
    if (value !== undefined) return value;
    if (pending.has(key)) return pending.get(key);
  }
  const promise = Promise.resolve().then(request).then(value => { cache.set(key, { value, time: Date.now() }); return value; }).finally(() => pending.delete(key));
  pending.set(key, promise);
  return promise;
}
export function invalidateCache(namespaces = []) {
  const names = Array.isArray(namespaces) ? namespaces : [namespaces];
  for (const key of cache.keys()) if (names.some(n => key.includes(`::${n}::`))) cache.delete(key);
  for (const key of pending.keys()) if (names.some(n => key.includes(`::${n}::`))) pending.delete(key);
}
export function clearAllRequestCache() { cache.clear(); pending.clear(); }
